<template>
  <div class="notices">
    <BaseInfo v-if="showAllergens" @close="updateAllergensClosedActive(true)">
      <template #icon><BaseIcon size="20" type="info" name="warning" /></template>
      <div class="allergy-text">
        Jadłospis zawiera produkt, na który Twój pacjent ma alergię, nietolerancję lub nie lubi
        produktu którego użyłeś
      </div>
      <div class="allergy-info">
        <div v-for="item in allergenLegend" :key="item.label" class="allergy-info__element">
          <div :class="['allergy-info__square', item.className]" />
          {{ item.label }}
        </div>
      </div>
    </BaseInfo>
    <BaseInfo v-if="showIncompleteData" @close="updateIncompleteDataInfoClosedActive(true)">
      <template #icon><BaseIcon size="20" type="info" name="info" /></template>
      Twój jadłospis zawiera produkty z niepełnymi danymi odnośnie wartości odżywczych
    </BaseInfo>
    <BaseInfo v-if="showLosses" @close="updateLossesClosedActive(true)">
      <template #icon><BaseIcon size="20" name="delete_sweep" /></template>
      W jadłospisie uwzględniono straty talerzowe (sprawdź w zakładce założenia diety)
    </BaseInfo>
  </div>
</template>

<script lang="ts" setup>
  import { storeToRefs } from 'pinia'
  import { computed } from 'vue'

  import BaseIcon from '@/components/BaseIcon.vue'
  import BaseInfo from '@/components/BaseInfo.vue'
  import { useDietsStore } from '@/store/dietsStore'
  import { useGlobalStore } from '@/store/globalStore'

  const dietStore = useDietsStore()
  const { hasPerm } = useGlobalStore()
  const {
    allergensInfo,
    allergensClosed,
    incompleteDataInfo,
    incompleteDataInfoClosed,
    lossesClosed,
    diet,
  } = storeToRefs(dietStore)
  const {
    updateAllergensClosedActive,
    updateIncompleteDataInfoClosedActive,
    updateLossesClosedActive,
  } = dietStore

  const allergenLegend = [
    { className: 'notlike', label: 'nielubiane' },
    { className: 'like', label: 'lubiane' },
    { className: 'allergy', label: 'alergia' },
    { className: 'intolerance', label: 'nietolerancja' },
  ]
  const showAllergens = computed(
    () => allergensInfo.value && !allergensClosed.value && hasPerm('accounts.patient_allergens'),
  )
  const showIncompleteData = computed(
    () => incompleteDataInfo.value && !incompleteDataInfoClosed.value,
  )
  const showLosses = computed(
    () => Boolean(diet.value?.data.inevitable_losses.active) && !lossesClosed.value,
  )
</script>

<style scoped>
  .allergy-text {
    flex-grow: 1;
    align-self: center;
  }

  .allergy-info {
    display: flex;
    flex-flow: row wrap;
    gap: 12px;
  }

  .allergy-info__square {
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-right: 8px;
    line-height: 12px;
  }

  .allergy-info__square.notlike {
    background: var(--color-warning-60);
  }

  .allergy-info__square.like {
    background: var(--color-success-60);
  }

  .allergy-info__square.allergy {
    background: #faa0a8;
  }

  .allergy-info__square.intolerance {
    background: #a0a8fa;
  }
</style>
